import type { RootState } from '~/src/redux/store';
import type { RegionsDataInterface } from '~/src/repositories/regions/regions.repository';

export const selectCurrentRegion = (state: RootState): RegionsDataInterface => state.geolocation.currentRegion;
export const selectIsShowGeolocationBlock = (state: RootState): boolean => state.geolocation.isShowGeolocationBlock;
